import {Component, EventEmitter, Input, OnInit, Output, signal, Signal} from '@angular/core';

@Component({
    selector: 'app-cl-tab',
    templateUrl: './cl-tab.component.html',
    styleUrls: ['./cl-tab.component.scss'],
  standalone: false
})
export class ClTabComponent implements OnInit {

  @Input() tab_title: string;

  /**
   * Stable id for remembering this tab across reloads. Only used when the enclosing `app-cl-tabs`
   * sets `rememberAs`; the title is not usable for it, since it is display text that may be
   * reworded without anyone thinking of the stored value.
   */
  @Input() key: string | null = null;

  active = signal<boolean>(false);

  @Output() activated = new EventEmitter<void>();

  constructor() { }

  ngOnInit(): void {
  }

}
